import './EditAvatar.scss';
import { AvatarUploadModal } from './AvatarUploadModal';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CurrentUserAvatar } from '@ui/header';
import React, { useState } from 'react';

export const EditAvatar: React.FC = () => {
	const [ isEditOpen, setIsEditOpen ] = useState(false);

	const toggleModal = () => setIsEditOpen((value) => !value);

	return (
		<div className='edit-avatar'>
			<CurrentUserAvatar large />
			<Button
				onClick={ toggleModal }
				type='link'>
				{ COPY_SPECIFIC.EDIT }
			</Button>
			<AvatarUploadModal
				onAfterSave={ toggleModal }
				onCancel={ toggleModal }
				open={ isEditOpen } />
		</div>
	);
};
